module.exports = __webpack_public_path__ + "static/media/logo.f9b2cc62.svg";